import React, { Component } from "react";
import connect from "react-redux/es/connect/connect";
import { withRouter } from "react-router";
import PropTypes from "prop-types";

import {
  Button,
  Dropdown,
  Header,
  Icon,
  Label,
  Popup,
} from "semantic-ui-react";

import { SetMenuFilters } from "data/filters/actions";

const maxDropdownHeight = 400;

class TagFilters extends Component {
  static propTypes = {
    hub: PropTypes.object.isRequired,
    filters: PropTypes.object.isRequired,
    allTags: PropTypes.object.isRequired,
    setFilters: PropTypes.func.isRequired,
    tagFilterType: PropTypes.string.isRequired,
  };

  state = {
    searchInput: "",
    selectedIndex: 0,
  };

  tagSelected = (tagId) => {
    const { filters, setFilters } = this.props;
    const filtersCopy = { ...filters };
    const filteredTags = filtersCopy ? filtersCopy.tags : [];
    filteredTags.push(tagId);
    setFilters(filtersCopy);
    this.setState({ searchInput: "", selectedIndex: 0 });
  };

  scrollMenu = () => {
    // handle scrolling when navigating by key presses
    const menu = document.getElementById("filtering_dropdown_menu");
    const selectedItem = document.getElementById(
      "filtering_dropdown_menu_selected_item"
    );
    if (!selectedItem) return;
    const menuY = menu.getBoundingClientRect().y;
    const selectedY = selectedItem.getBoundingClientRect().y;
    const selectedHeight = selectedItem.getBoundingClientRect().height;
    const selectedDist = selectedY - menuY;
    if (selectedDist + selectedHeight > maxDropdownHeight) {
      menu.scrollTop += selectedDist - maxDropdownHeight + selectedHeight;
    } else if (selectedDist < 0) {
      menu.scrollTop += selectedDist;
    }
  };

  handleKeyDown = (e) => {
    // handle key down and enter key presses
    const { selectedIndex } = this.state;
    const tags = this.tagsDropdownList;
    if (tags.length < 1) return;
    if (e.key === "Enter") {
      this.tagSelected(tags[selectedIndex]);
    } else if (e.key === "ArrowUp") {
      this.setState((state) => {
        return { selectedIndex: Math.max(selectedIndex - 1, 0) };
      }, this.scrollMenu);
    } else if (e.key === "ArrowDown") {
      this.setState((state) => {
        return { selectedIndex: (selectedIndex + 1) % tags.length };
      }, this.scrollMenu);
    }
  };

  handleTyping = (e) => {
    this.setState({ searchInput: e.target.value, selectedIndex: 0 });
  };

  getTagOptions = () => {
    const { hub } = this.props;
    const tagOptions = [];

    hub.tags
      .sort((a, b) => {
        return a.name > b.name ? 1 : -1;
      })
      .forEach((tag) => {
        tagOptions.push({
          color: tag.color,
          content: (
            <div style={{ display: "flex", alignItems: "center" }}>
              <Label
                empty
                circular
                style={{ backgroundColor: tag.color, marginRight: "1em" }}
              />
              <div>{tag.name}</div>
            </div>
          ),
          key: tag.id,
          text: tag.name,
          type: "tag",
          value: tag.id,
        });
      });
    return tagOptions;
  };

  generateTagsList = () => {
    const { hub, filters } = this.props;
    const { tags } = hub;
    const filteredTags = filters ? filters.tags : [];
    const dropdownList = [];
    tags.forEach((tag) => {
      const filtered =
        filteredTags.find((t) => {
          return t === tag.id;
        }) != null;
      if (!filtered) {
        dropdownList.push(tag.id);
      }
    });
    return dropdownList;
  };

  dropdownOnChange = (data) => {
    const { filters, setFilters } = this.props;
    const filtersCopy = { ...filters };
    let { tags } = filtersCopy;

    tags = tags.filter((id) => {
      return data.value.indexOf(id) >= 0;
    });
    filtersCopy.tags = tags;
    setFilters(filtersCopy);
  };

  clearFilter = () => {
    const { filters, setFilters } = this.props;
    const filtersCopy = { ...filters };
    filtersCopy.tags = [];
    setFilters(filtersCopy);
  };

  filterByInput = (list) => {
    const { searchInput } = this.state;
    const { allTags } = this.props;
    const filterText = searchInput.toLowerCase();
    return list.filter((id) => {
      const item = allTags[id];
      const itemText = item.name.toLowerCase();
      return itemText.includes(filterText);
    });
  };

  setFilterType = (type) => {
    const { filters, setFilters } = this.props;
    const filtersCopy = { ...filters };
    filtersCopy.tagFilterType = type;
    setFilters(filtersCopy);
  };

  selectorMarkup = () => {
    const { searchInput, selectedIndex } = this.state;
    const { filters, allTags } = this.props;
    const { tags } = filters;
    this.tagsDropdownList = this.filterByInput(this.generateTagsList());
    return (
      <div
        style={{
          padding: "1px 1em",
          height: "max-content",
        }}
      >
        <div
          style={{
            width: "400px",
            maxHeight: "400px",
          }}
        >
          <Dropdown
            data-test="filter-menu-tags"
            className="selection" // Can't have children and use selection prop, so to get styling just add the className instead
            placeholder="Select Tags"
            fluid
            deburr
            search
            onChange={(event, data) => {
              this.dropdownOnChange(data);
            }}
            searchInput={{ value: searchInput }}
            onClose={() => {
              this.setState({ searchInput: "" });
            }}
            onKeyDown={this.handleKeyDown}
            onSearchChange={this.handleTyping}
            options={this.getTagOptions()}
            value={tags}
            style={{
              marginTop: "1px",
              position: "relative",
            }}
            renderLabel={(item, index, object) => {
              object.content = item.text;
              object.className = "rule_modal_dropdown_tag_label";
              object.icon = "hashtag";
              return object;
            }}
            multiple
            selection
          >
            <Dropdown.Menu
              id="filtering_dropdown_menu"
              style={{
                paddingBottom: "1em",
                maxHeight: `${maxDropdownHeight}px`,
              }}
            >
              <Dropdown.Header content="Tags" style={{ fontSize: "10pt" }} />
              {this.tagsDropdownList.length > 0 ? (
                this.tagsDropdownList.map((tagId, index) => {
                  const selected = index === selectedIndex;
                  const tag = allTags[tagId];
                  return (
                    <Dropdown.Item
                      icon={<Icon name="hashtag" />}
                      key={tagId}
                      text={tag.name}
                      onClick={() => {
                        this.tagSelected(tagId);
                      }}
                      selected={selected}
                      id={
                        selected ? "filtering_dropdown_menu_selected_item" : ""
                      }
                    />
                  );
                })
              ) : (
                <span style={{ marginLeft: "2em", color: "grey" }}>
                  No matching tags
                </span>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    );
  };

  render() {
    const { filters } = this.props;
    const { tagFilterType } = filters;
    return (
      <React.Fragment>
        <div style={{ display: "flex", alignItems: "center" }}>
          <div>
            <Header as="h4" style={{ display: "inline", marginRight: "0.5em" }}>
              Tags
            </Header>
          </div>
          <div
            style={{ marginRight: "0.5em", marginLeft: "auto" }}
            data-test="filter-tags-all-any"
          >
            <Button.Group>
              <Button
                primary={tagFilterType === "ALL"}
                compact
                onClick={() => {
                  this.setFilterType("ALL");
                }}
              >
                ALL
              </Button>
              <Button
                primary={tagFilterType === "ANY"}
                compact
                onClick={() => {
                  this.setFilterType("ANY");
                }}
              >
                ANY
              </Button>
            </Button.Group>
          </div>
          <div>
            <Popup
              on="hover"
              wide
              position="right center"
              trigger={<Icon color="grey" name="question circle" />}
            >
              Use ALL to display client cards where all selected filters apply.
              Use ANY to display client cards where any of the selected filters
              apply
            </Popup>
          </div>
        </div>
        {this.selectorMarkup()}
        <div>
          <Popup
            content="Clear"
            on="hover"
            position="top center"
            trigger={
              <Icon
                data-test="filter-menu-tags-clear"
                name="delete"
                onClick={this.clearFilter}
                link
                color="grey"
              />
            }
          />
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    hub: state.hubly.data.hub.selected.hub,
    allTags: state.hubly.data.hub.tags,
    filters: state.hubly.data.filters,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setFilters: (filters) => {
      dispatch(SetMenuFilters(filters));
    },
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TagFilters)
);
